import { Outlet } from 'react-router';

export function MarketingLayout() {
  return <Outlet />;
}
